import { render, staticRenderFns } from "./lawsuit_3.vue?vue&type=template&id=40db5d2a&scoped=true"
import script from "./lawsuit_3.vue?vue&type=script&lang=js"
export * from "./lawsuit_3.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_3.vue?vue&type=style&index=0&id=40db5d2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db5d2a",
  null
  
)

export default component.exports